import { HideToast, ShowToast } from '@api/store/toast/actions';
import { AxiosError } from 'axios';
import { put } from 'redux-saga/effects';
import { Logger } from '@api/services/errors/appLogger';

const isAxiosError = <T extends Record<'ErrorParams' | 'Error', any>>(e: Error | AxiosError<T>): e is AxiosError<T> => {
    return (e as AxiosError)?.response !== undefined;
};

export function* errorToast(e: AxiosError | Error): any {
    const message = isAxiosError(e) ? e?.response?.data?.Error : e?.message;

    Logger.error(message);

    yield put(
        ShowToast({
            severity: 'error',
            message: `Error: ${message}`,
            duration: 6000,
            onClose: HideToast,
        })
    );
}
